import { Route, Routes } from 'react-router-dom';
import './App.css';
import AboutMe from './Pages/AboutMe';
import Blogs from './Pages/Blogs';
import Education from './Pages/Education';
import Experience from './Pages/Experience';
import Home from './Pages/Homepage/Home';
import Projects from './Pages/Homepage/Projects';
import SingleProjectDetails from './Pages/Homepage/SingleProjectDetails';
import Footer from './Pages/Shared/Footer';
import Header from './Pages/Shared/Header';

function App() {
  return (
    <div className="">
      <Header></Header>
      <Routes>
        <Route path='/' element={<Home></Home>}></Route>
        <Route path='education' element={<Education></Education>}></Route>
        <Route path='experience' element={<Experience></Experience>}></Route>
        <Route path='/singleprojectdetails' element={<SingleProjectDetails></SingleProjectDetails>}></Route>
        <Route path='aboutme' element={<AboutMe></AboutMe>}></Route>
        <Route path='projects' element={<Projects></Projects>}/>
        <Route path='blogs' element={<Blogs></Blogs>}/>
      </Routes>
      <Footer></Footer>
    </div>
  );
}

export default App;
